import * as React from "react";
import { TestIdsEnum } from "../../TestIdsEnum";
import * as yup from "yup";
import * as Inputs from "../common/hook-form/index";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { ActionSpinner } from "../../components/ActionSpinner";

interface OwnProps {
  onSubmit: (data: LoginFormValues) => void;
  isLoading: boolean;
  hasUsernameOrPasswordError: boolean;
}

type LoginFormValues = {
  username: string;
  password: string;
};

const validationSchema = yup.object().shape({
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
});

export const LoginForm: React.FC<OwnProps> = (props) => {
  const methods = useForm<LoginFormValues>({
    defaultValues: {
      username: "",
      password: "",
    },
    /* @ts-ignore */
    resolver: yupResolver(validationSchema),
  });

  return (
    <form
      onSubmit={methods.handleSubmit(props.onSubmit)}
      data-test={TestIdsEnum.LoginForm}
    >
      <div className="card-title">Login to your account</div>
      <Inputs.InputFormField
        errors={methods.formState.errors}
        register={methods.register}
        label="Username"
        name="username"
      />
      <Inputs.InputFormField
        errors={methods.formState.errors}
        register={methods.register}
        label="Password"
        type="password"
        name="password"
      />
      <div className="form-footer">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={props.isLoading}
          data-test={TestIdsEnum.LoginFormSubmitButton}
        >
          {props.isLoading ? <ActionSpinner /> : "Sign in"}
        </button>
      </div>
    </form>
  );
};
